import { ELDEST_PROJECTS, PROJECTS } from "../../data/projects";
import { WINDOW_IDS, WINDOW_MENU } from "../../data/windows";
import { useWindowManager } from "../../context/WindowContext";
import { Window } from "../Window/Window";
import classes from "./ProjectsBin.module.css";

export const ProjectsBin = ({ id = WINDOW_IDS.PROJECTS, items = PROJECTS }) => {
  const { open } = useWindowManager();
  const projectsCount = items.length;

  return (
    <Window
      id={id}
      classes={classes}
      menuItems={WINDOW_MENU}
      footer={
        <div className={classes.downPanel}>
          <div className={classes.leftDownPanel}>
            <p>{`${projectsCount} project(s)`}</p>
          </div>
          <div className={classes.rightDownPanel}>
            <p>{`${projectsCount * 7}.00 KB`}</p>
          </div>
        </div>
      }
    >
      {items.map((project) => (
        <div className={classes.Project} key={project.name}>
          <a
            href={project.url || "#"}
            target={project.type === "folder" ? undefined : "_blank"}
            rel="noopener noreferrer"
            onClick={
              project.type === "folder"
                ? (event) => {
                    event.preventDefault();
                    open(project.windowId);
                  }
                : undefined
            }
            className={classes.ProjectLink}
          >
            <img src={project.pic} alt={project.name} />
            <p>{project.name}</p>
          </a>
        </div>
      ))}
    </Window>
  );
};

export const EldestOne = () => (
  <ProjectsBin id={WINDOW_IDS.ELDEST} items={ELDEST_PROJECTS} />
);
